export const errorPages = {
    'error.page.404.title': '错误 404',
    'error.page.404.text': '你在找些什么吗？这里似乎没有任何东西了',
    'error.page.500.title': '错误 500',
    'error.page.500.text': '似乎出了点问题。我们正在排除故障，请稍后再登录平台',
    'error.page.503.title': '错误 503',
    'error.page.503.text': '服务器目前暂时不可用，但我们已在处理这一情况。请稍候再尝试重新登录',
    'error.page.support.button': '你有疑问吗？请联系我们的支持团队',
}
